import React from 'react';
import { DataCollectionGapSummaryQuestionnaire } from '../../../../store/Models/Api/DataCollectionGapSummaryModels';
import { useLocalizer } from '../hooks/useLocalizer';
import {
    getQuestionnaireRequiredQuestionAnswered,
    getQuestionnaireRequiredQuestionUnanswered
} from './helpers/gapSummaryHelpers';
import QuestionList from './QuestionList';

interface QuestionnaireGapGroupProps {
    questionnaire: DataCollectionGapSummaryQuestionnaire;
    showQuestionnaireName?: boolean;
}

export const QuestionnaireGapGroup: React.FC<QuestionnaireGapGroupProps> = ({
    questionnaire,
    showQuestionnaireName = true
}) => {
    const localize = useLocalizer();
    const requiredQuestionsAnswered = getQuestionnaireRequiredQuestionAnswered(questionnaire);
    const unansweredCount = getQuestionnaireRequiredQuestionUnanswered(questionnaire);
    const requiredQuestionsTotal = requiredQuestionsAnswered + unansweredCount;

    if (unansweredCount === 0) {
        return null;
    }

    const renderCounts = () => (
        <span className="gap-summary-gap-group-counts">
            {requiredQuestionsAnswered}/{requiredQuestionsTotal} {localize('answered')}
        </span>
    );

    return (
        <div className="gap-summary-gap-group">
            {showQuestionnaireName && (
                <div className="gap-summary-gap-group-title">
                    <span>{questionnaire.name ? localize(questionnaire.name) : localize('Questionnaire')}</span>
                    {renderCounts()}
                </div>
            )}
            {questionnaire.pages?.map((page, pageIndex) => (
                <div className={`gap-summary-page-group${showQuestionnaireName ? '' : ' gap-summary-page-group-promoted'}`} key={`${questionnaire.id}-${page.pageName}`}>
                    <div className={`gap-summary-page-title${!showQuestionnaireName && pageIndex === 0 ? ' gap-summary-page-title-with-counts' : ''}`}>
                        <span>{page.pageName ? localize(page.pageName) : localize('Page')}</span>
                        {!showQuestionnaireName && pageIndex === 0 && renderCounts()}
                    </div>
                    <QuestionList questions={page.questions} />
                </div>
            ))}
        </div>
    );
};

export default QuestionnaireGapGroup;
